import {
  PrimaryAction,
  SampleType,
  TestCard,
} from "@app/provider/testData/types";
import { IntlShape } from "react-intl";
import { messages } from "@app/provider/testData/messages";
import { ConnectTestCardBase } from "@app/provider/testData/testCard/connect/ConnectTestCardBase";

export class HorizonTestCard extends ConnectTestCardBase {
  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (!testCard.sampleReceivedDate) {
      return intl.formatMessage(
        messages.testCardDefaultDescSampleReceivedHorizon
      );
    }
    return super.getDescriptionForSampleReceived(testCard, intl);
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return testCard.sampleType === SampleType.BLOOD
      ? PrimaryAction.SCHEDULE_A_DRAW
      : undefined;
  }
}
